
import { defineComponent, reactive } from "vue";
import CustomSearch from "./CustomSearch.vue";

export default defineComponent({
  name: "custom-filter-button",
  components: {
    CustomSearch,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
  },
  setup() {
    let data = reactive({
      show_drop_down_menu: false,
    });

    return {
      data,
    };
  },

  methods: {
    getFilledData(event) {
      if (!event.length) return;
      const customSearch = {};
      for (const key of event) {
        if (key["value"]) {
          customSearch[key["name"]] = key["value"];
        }
      }

      this.$emit("data", customSearch);
    },
    getSelectedData(event) {
      this.$emit("selected", event);
      this.$emit("ufSelected", event);
    },
    showDropDownMenu() {
      this.data.show_drop_down_menu = true;
    },
    hideDropDownMenu() {
      this.data.show_drop_down_menu = false;
    },
    getCanceled(event) {
      this.$emit("canceled", event);
    },
    getCleaned(event) {
      this.$emit("cleaned", event);
      this.$emit("limpar");
    },
  },
});
